import React from 'react';
import Typewriter from 'components/Typewriter';
import Scrollchor from 'react-scrollchor';

class Hero extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      

      <div className="hero-container">
        <Typewriter className="hero-title" text="hkodes.app" />

        <div className="hero-description">
          I am a web developer with a passion for building functional applications and
          eye-catching user experiences.<br />Check out my some of my {' '}
          <Scrollchor to="#projects">side projects</Scrollchor> below!
        </div>
      </div>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js